<template functional>
    <button :class="['like js-like', { 'is-liked' : props.model.liked }]"
            :data-like-type="props.model.typeName"
            :data-like-id="`pr${props.model.productId}`"
            :data-like-count="props.model.likes"
            :data-like-liked="props.model.liked"
            title="Dodaj do ulubionych"
            data-t="1.1">
        <svg class="like__image"
             :width="props.size"
             :height="props.size"
             viewBox="0 0 14 12">
            <path class="like__path"
                  d="M3.06217 0.765301C1.95883 1.0613 1 2.02995 1 3.66709C1 4.36547 1.13836 4.96868 1.56767 5.6617C2.0138 6.38187 2.78842 7.22186 4.11784 8.34873L6.83488 10.6074C6.92987 10.6864 7.07013 10.6864 7.16512 10.6074L9.88215 8.34874C11.2116 7.22188 11.9862 6.38189 12.4323 5.66172C12.8616 4.9687 13 4.36548 13 3.66712C13 2.02997 12.0412 1.06133 10.9378 0.765332C9.81763 0.464813 8.47271 0.834828 7.64143 2.09852C7.50178 2.31081 7.25989 2.43934 7 2.43934C6.74011 2.43934 6.49821 2.3108 6.35856 2.09851C5.52729 0.834794 4.18237 0.464781 3.06217 0.765301Z" stroke-linecap="round" stroke-linejoin="round">
            </path>
        </svg>
    </button>
</template>
<script>
    export default {
        name: 'dm-like-button',
        props: {
            model: {
                type: Object
            },
            size: {
                type: String,
                default: '14'
            }
        }
    };
</script>
